import { render, staticRenderFns } from "./GroupTagging.vue?vue&type=template&id=3f392fbc&scoped=true"
import script from "./GroupTagging.vue?vue&type=script&lang=js"
export * from "./GroupTagging.vue?vue&type=script&lang=js"
import style0 from "./GroupTagging.vue?vue&type=style&index=0&id=3f392fbc&prod&scoped=true&lang=css"
import style1 from "./GroupTagging.vue?vue&type=style&index=1&id=3f392fbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f392fbc",
  null
  
)

export default component.exports